import { CrudModel } from "./_crud";

export class BlogPostCategoryAdminModel extends CrudModel {
	constructor() {
		super("admin/blog_post_category");
	}
}

export default new BlogPostCategoryAdminModel();
